module.exports = __webpack_public_path__ + "static/media/3AA7D8_0_0.0214d4a8.woff2";